import { Injectable } from '@angular/core';
import { Eloqua } from '@interfaces/forms';
import { ELOQUA_CACHE_TIME } from '@core/config';

@Injectable({ providedIn: 'root' })
export class EloquaFormCache {
  private cache: Record<number, { expires: number; config: Eloqua.FormConfig }> = {};

  public setItem(id: number, config: Eloqua.FormConfig): void {
    this.cache[id] = { expires: Date.now() + ELOQUA_CACHE_TIME, config };
  }

  public getItem(id: number): Promise<Eloqua.FormConfig> {
    const cacheItem = this.cache[id];

    if (!cacheItem) {
      return Promise.reject();
    }

    if (cacheItem.expires < Date.now()) {
      this.removeItem(id);
      return Promise.reject();
    }

    return Promise.resolve(cacheItem.config);
  }

  public removeItem(id: number): void {
    delete this.cache[id];
  }
}
